<div class="bciti-shape-select-container" [ngStyle]="{ 'width': width }">
  <label>{{ 'common.shape' | translate }}</label>
  <div class="bciti-select"
    [class.valid]="valid"
    [class.invalid]="invalid"
    [class.touched]="touched"
    [class.validation]="validation"
    (click)="showDropdown()"
    #drop
  >
    <div class="bciti-shape-select-option option-selected">
      <div class="shape-option" [ngStyle]="getShapeStyle(value)"></div>
      <span class="icon-caret-down"></span>
    </div>
    <app-bciti-select-grid-dropdown [scrollable]="false" [reference]="drop">
      <div class="bciti-shape-select-option grid-option" *ngFor="let shape of shapes" (click)="select(shape)">
        <div class="shape-option" [ngStyle]="getShapeStyle(shape)"></div>
      </div>
    </app-bciti-select-grid-dropdown>
  </div>
</div>
